module.exports = __webpack_public_path__ + "static/img/icon.fc12c195.svg";